module.exports = __webpack_public_path__ + "static/case-study-roguemark-0dfe141dd30a7d2921a67204f2552438.jpg";